/**
 * IntelligenceHealthBadge - Displays the active Runtime Context Pack (RCP) version.
 * Used in chat interfaces to show the 'intelligence' version powering the experience.
 */
import React from 'react';
import { Badge } from './badge';
import { SparklesIcon } from '@heroicons/react/24/outline';
import { cn } from '../../shared/lib/cn';

export interface IntelligenceHealthBadgeProps {
  version?: number | null;
  className?: string;
  size?: 'sm' | 'md';
}

export function IntelligenceHealthBadge({
  version,
  className,
  size = 'md'
}: IntelligenceHealthBadgeProps) {
  if (!version) return null;

  return (
    <Badge
      variant="info"
      className={cn(
        "gap-1.5 font-medium border-sky-100 dark:border-sky-800/50 transition-all hover:scale-105 cursor-default",
        size === 'sm' ? "px-1.5 py-0 text-[10px]" : "px-2.5 py-0.5 text-xs",
        className
      )}
    >
      <SparklesIcon className={cn(
        "text-sky-500 animate-pulse",
        size === 'sm' ? "w-2.5 h-2.5" : "w-3.5 h-3.5"
      )} />
      <span className="flex items-center gap-0.5">
        Intelligence <span className="opacity-60 font-normal">v{version}</span>
      </span>
    </Badge>
  );
}
